export default "__VITE_ASSET__Dsc_JjNL__"